import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import ReactGA from 'react-ga';
import { ChildrenPropType } from '../../services/proptypes';

var Event = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Event, _React$Component);

  function Event() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Event.prototype;

  _proto.formatEventType = function formatEventType() {
    var eventType = this.props.eventType;
    return "on" + eventType[0].toUpperCase() + eventType.substring(1);
  };

  _proto.wrapEventHandler = function wrapEventHandler() {
    var _ref;

    var _this$props = this.props,
        children = _this$props.children,
        event = _this$props.event;
    var formattedEventType = this.formatEventType();
    var childEventHandler = children.props[formattedEventType];
    return _ref = {}, _ref[formattedEventType] = function () {
      ReactGA.event(event);

      if (childEventHandler) {
        childEventHandler();
      }
    }, _ref;
  };

  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.cloneElement(children, _extends({}, children.props, this.wrapEventHandler()));
  };

  return Event;
}(React.Component);

export { Event as default };
Event.defaultProps = {};